import { Inject, inject, Injectable } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest,
  SilentRequest,
} from '@azure/msal-browser';
import { filter, firstValueFrom, takeUntil } from 'rxjs';
import { CommonService } from '../../../services/common.service';
import { AuthorizationService } from './authorization.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  loginDisplay = false;
  tokenExpiration: string = '';
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private commonService: CommonService,
    private authorizationService: AuthorizationService
  ) {
    // this.msalBroadcastService.inProgress$
    //   .pipe(
    //     filter((status: InteractionStatus) => status === InteractionStatus.None)
    //   )
    //   .subscribe(async () => {
    //     // const activeAccount = this.msalService.instance.getAllAccounts()[0];
    //     // this.msalService.instance.setActiveAccount(activeAccount);

    //     if (!this.authorizationService.user.length) {
    //       console.log('BROADCAST SERVICE');
    //       await this.setLoginDisplay();
    //     }
    //   });

    // Used for storing and displaying token expiration
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((msg) => {});
  }

  async initAuth() {
    // console.log('HIT');
    try {
      await this.msalService.instance.initialize();
    } catch (e) {
      console.warn(e);
    }

    try {
      const redirectResult =
        await this.msalService.instance.handleRedirectPromise();

      if (redirectResult) {
        // console.log('REDIRECT PROMISE');
        await this.setLoginDisplay();
      }
    } catch (err) {}
  }

  login() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  async setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      const activeAccount = this.msalService.instance.getAllAccounts()[0];
      this.msalService.instance.setActiveAccount(activeAccount);
      this.commonService.pageHeader = { loggedInUser: activeAccount.name };
      const res = await this.authorizationService.getUserRoleAsync(
        activeAccount.username
      );
      // this.authorizationService
      //   .getUserRoles(activeAccount.username)
      //   .subscribe((res) => {
      if (res) {
        const userRoles = res.map((r) => r.role_Name);
        this.commonService.pageHeader = { loggedInUserRole: userRoles };
        this.authorizationService.user = res;
      }
      // });
    }
  }

  silentAuthRequest() {
    const activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount) {
      console.warn('No active account found');
      this.login();
    }
    const silentRequest: SilentRequest = {
      account: activeAccount!,
      scopes: ['User.Read'],
    };

    return this.msalService.acquireTokenSilent(silentRequest);
  }

  async logoutSilent() {
    const res = await firstValueFrom(this.msalService.logout());
    return res;
  }
  // Log the user out
  logout() {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: window.location.origin + '/logout',
    });
  }
}
